<template>
  <!-- 1회 투약횟수 커스텀 데이터 입력 -->
  <div
    style="
      margin-top: -11px;
      border: var(--border-line);
      border-bottom-left-radius: 4px;
      border-bottom-right-radius: 4px;
      background-color: rgb(245, 245, 245);
      border: 1px solid rgb(236, 236, 236);
      padding: 4px;
    "
  >
    <input
      style="height: 25px; width: 70px; padding-right: 15px; margin-left: 10px"
      ref="fromTextInput"
      v-model="fromTextVal"
      type="text"
      class="no-spin-button"
      @input="handleInput"
    />
    <label style="font-size: 13px; padding-left: 10px; display: inline-block">
      {{ $t("label.perday_over") }}
    </label>
    <label
      style="
        font-size: 13px;
        padding-left: 10px;
        padding-right: 15px;
        display: inline-block;
      "
    >
      ~
    </label>
    <input
      style="height: 25px; width: 70px; padding-right: 15px"
      v-model="toTextVal"
      type="text"
      class="no-spin-button"
      @input="handleInput"
    />
    <label
      style="
        font-size: 13px;
        padding-left: 10px;
        padding-right: 15px;
        display: inline-block;
      "
    >
      {{ $t("label.perday_under") }}
    </label>
    <button
      class="btn"
      style="
        height: 25px;
        background-color: #8a8a8a;
        border-color: #8a8a8a;
        color: #fff;
      "
      @click="customPut($event, showContent.code)"
    >
      {{ $t("button.insert") }}
    </button>
  </div>
  <AlertDialog
    v-if="isAlertDialogOpen"
    :maxWidthOption="alertDialog.maxWidthOption"
    :title="alertDialog.title"
    :message="alertDialog.message"
    :afterEvent="alertDialog.afterEvent"
    @confirm="closeAlertDialog"
  />
</template>

<script>
import AlertDialog from "@/components/AlertDialog.vue";
import constants from "@/data/constants.js";
import { defineComponent, ref, onMounted } from "vue";
import { storeToRefs } from "pinia";
import { useI18n } from "vue-i18n";
import { useContentsStore } from "@/store/contents";

export default defineComponent({
  name: "DirectInputPerDay",
  props: ["parentMenu", "parentMenuCode"],
  components: {
    AlertDialog,
  },
  setup() {
    //AlertDialog
    const isAlertDialogOpen = ref(false);
    const alertDialog = ref({
      maxWidthOption: "",
      title: "",
      message: "",
      afterEvent: "",
    });
    const closeAlertDialog = (afterEvent) => {
      isAlertDialogOpen.value = false;
      if (afterEvent === "perDayCust") {
        fromTextInput.value.focus();
      }
    };

    const { t } = useI18n();
    const contentsStore = useContentsStore();
    const { showContent, selectedContent, itemEditModeYn } =
      storeToRefs(contentsStore);

    const handleInput = () => {
      // 입력된 값이 숫자가 아닌 경우 값을 제거합니다.
      fromTextVal.value = fromTextVal.value.replace(/\D/g, "");
      toTextVal.value = toTextVal.value.replace(/\D/g, "");
    };

    const fromTextInput = ref(null);
    const fromTextVal = ref("");
    const toTextVal = ref("");
    const customPut = () => {
      //합치기 편집중에는 항목에 추가 못함
      let itemEditMode = itemEditModeYn.value;
      if (itemEditMode) {
        alertDialog.value.message = t("message.validation_combi_edit");
        isAlertDialogOpen.value = true;
        return;
      }

      if (fromTextVal.value === "" && toTextVal.value === "") {
        // "숫자를 입력해 주시기 바랍니다
        alertDialog.value.message = t("message.validation_number");
        isAlertDialogOpen.value = true;
        alertDialog.value.afterEvent = "perDayCust";
        return;
      }

      if (
        fromTextVal.value !== "" &&
        toTextVal.value !== "" &&
        parseFloat(fromTextVal.value) > parseFloat(toTextVal.value)
      ) {
        // 앞의 1일 투약횟수가 더 작아야 합니다.
        alertDialog.value.message = t("message.validation_perday");
        isAlertDialogOpen.value = true;
        alertDialog.value.afterEvent = "perDayCust";
        return;
      }

      let name = "";
      let englishName = "";

      if (fromTextVal.value !== "" && toTextVal.value === "") {
        name = fromTextVal.value + "회 이상";
        englishName = "over " + fromTextVal.value;
      } else if (fromTextVal.value === "" && toTextVal.value !== "") {
        name = toTextVal.value + "회 이하";
        englishName = "under " + toTextVal.value;
      } else {
        name = fromTextVal.value + "~" + toTextVal.value + "회 이하";
        englishName = fromTextVal.value + " ~ " + toTextVal.value;
      }

      if (parseFloat(fromTextVal.value) >= 10000) {
        //9999회 이상의 투약횟수 정보는 제공하지 않습니다.\n직접 입력에서 {perDay} 이상을 입력할 경우, 범위가 9999회 이상으로 변환되어 분석됩니다.
        //When you want to analyze the 9999 and over, we don't offer detail about.\n If you set the {perDay} over, the range is converted to 'Over 9999' and analyzed
        let perDay = fromTextVal.value;
        alertDialog.value.message = t("message.notice_perday_from_9999over", {
          perDay,
        });
        isAlertDialogOpen.value = true;
        fromTextVal.value = "9999";
        toTextVal.value = "";
        name = fromTextVal.value + "회 이상";
        englishName = "over " + fromTextVal.value;
      }

      if (parseFloat(toTextVal.value) >= 10000) {
        //9999회 이상의 투약횟수 정보는 제공하지 않습니다.\n직접 입력에서 {perDay} 이하를 입력할 경우, 범위가 1회 이상으로 변환되어 분석됩니다.
        //When you want to analyze the 9999 and over, we don't offer detail about.\n If you set the {perDay} under, the range is converted to 'Over 1' and analyzed
        let perDay = toTextVal.value;
        alertDialog.value.message = t("message.notice_perday_to_9999over", {
          perDay,
        });
        isAlertDialogOpen.value = true;
        fromTextVal.value = "1";
        toTextVal.value = "";
        name = fromTextVal.value + "회 이상";
        englishName = "over " + fromTextVal.value;
      }

      const data = {
        code: constants.CONSTANT_PERDAY_DETAIL_CODE,
        id: `${fromTextVal.value.toString()}-${toTextVal.value.toString()}`,
        fromId: fromTextVal.value.toString(),
        toId: toTextVal.value.toString(),
        itemName: name,
        itemEnglishName: englishName,
        name: name,
        englishName: englishName,
        type: 3, // 직접입력
      };

      if (selectedContent.value.list.find(l => l.id === data.id)) {
        // "이미 추가된 항목입니다"
        alertDialog.value.message = t("message.validation_existsItem");
        isAlertDialogOpen.value = true;
        return;
      }

      //기본 전체 삭제
      const removeIndex = selectedContent.value.list.findIndex(
        (c) =>
          c.code + "_" + c.type === showContent.value.code + "_98" ||
          c.code + "_" + c.type === showContent.value.code + "_97"
      );
      if (removeIndex > -1) {
        selectedContent.value.list.splice(removeIndex, 1);
      }

      selectedContent.value.list.push(data);

      fromTextVal.value = "";
      toTextVal.value = "";
    };

    onMounted(() => {
      fromTextVal.value = "";
      toTextVal.value = "";
    });

    return {
      //AlertDialog
      isAlertDialogOpen,
      alertDialog,
      closeAlertDialog,
      //설정값
      constants,

      showContent,
      selectedContent,

      customPut,
      fromTextInput,
      fromTextVal,
      toTextVal,
      handleInput,
    };
  },
});
</script>

<style scoped>
/* 숫자만 입력 가능 */
.no-spin-button::-webkit-inner-spin-button,
.no-spin-button::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
.no-spin-button {
  appearance: textfield;
}
</style>
